import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'empresas/clases-de-declaraciones-empresariales/';

/**
 * GET Clases de Declaraciones Empresariales
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getClasesDeDeclaracionesEmpresariales = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Clase de Declarcion Empresarial
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getClaseDeDeclaracionEmpresarial = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Clase de Declaracion empresarial
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClaseDeDeclaracionEmpresarial = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Clase de Declaracion Empresarial
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchClaseDeDeclaracionEmpresarial = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Clase de Declaracion Empresarial
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteClaseDeDeclaracionEmpresarial = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
